import { ANDROID_LINK, DEEPLINK, DEFAULT_LINK, IPHONE_LINK, MOBILE_MARKETS, MOBILE_OS } from '@r1-frontend/entities/Layout/_deps/constants';
import { getUrlString } from '@r1-frontend/entities/Layout/_deps/helpers/url';

export const getMobileLink = (accessToken, refreshToken, agreement, city, mobileOs) => {
    let link;
    switch (mobileOs) {
        case MOBILE_OS.iphone:
            link = getIosMobileLink(accessToken, refreshToken, agreement, city);
            break;
        case MOBILE_OS.android:
            link = getAndroidMobileLink(accessToken, refreshToken, agreement, city);
            break;
        default:
            link = getDetectMobileLink(accessToken, refreshToken, agreement, city);
      }

    return link;
};

export const getDetectMobileLink = (accessToken, refreshToken, agreement, city) => {
    let link;
    if (accessToken && (isAndroid() || isIphone())) {
        const queryParam = {
            token: accessToken,
            refresh_token: refreshToken,
            agreement_number: agreement,
            city_id : city.cityId,
        };
        const queryString = getUrlString(queryParam);
        link = DEEPLINK +
            window.location.href + '?' +
            encodeURIComponent(queryString) + '&' +
            getUrlString(MOBILE_MARKETS);
    } else if (isAndroid()) {
        link = ANDROID_LINK;
    } else if (isIphone()) {
        link = IPHONE_LINK;
    } else {
        link = DEFAULT_LINK;
    }
    return link;
};

export const getAndroidMobileLink = (accessToken, refreshToken, agreement, city) => {
    let link;
    if (accessToken && isAndroid()) {
        const queryParam = {
            token: accessToken,
            refresh_token: refreshToken,
            agreement_number: agreement,
            city_id : city.cityId,
        };
        const queryString = getUrlString(queryParam);
        link = DEEPLINK +
            window.location.href + '?' +
            encodeURIComponent(queryString) + '&' +
            getUrlString(MOBILE_MARKETS);
    } else {
        link = ANDROID_LINK;
    }
    return link;
};

export const getIosMobileLink = (accessToken, refreshToken, agreement, city) => {
    let link;
    if (accessToken && isIphone()) {
        const queryParam = {
            token: accessToken,
            refresh_token: refreshToken,
            agreement_number: agreement,
            city_id : city.cityId,
        };
        const queryString = getUrlString(queryParam);
        link = DEEPLINK +
            window.location.href + '?' +
            encodeURIComponent(queryString) + '&' +
            getUrlString(MOBILE_MARKETS);
    } else {
        link = IPHONE_LINK;
    }
    return link;
};

export const isAndroid = () => {
    return window.navigator.userAgent.match(/Android/i);
};

export const isMacOS = () => {
    return window.navigator.userAgent.match(/Mac OS/i);
};

export const isLinux = () => {
    return window.navigator.userAgent.match(/Linux/i);
};

export const isIphone = () => {
    return window.navigator.userAgent.match(/iPhone/i) ||
        window.navigator.userAgent.match(/iPod/i) ||
        window.navigator.userAgent.match(/iPad/i);
};

export const isMobile = () => {
    return window.navigator.userAgent.match(/Android/i) ||
        window.navigator.userAgent.match(/webOS/i) ||
        window.navigator.userAgent.match(/iPhone/i) ||
        window.navigator.userAgent.match(/iPod/i) ||
        window.navigator.userAgent.match(/iPad/i) ||
        window.navigator.userAgent.match(/BlackBerry/i) ||
        window.navigator.userAgent.match(/Windows Phone/i);
};
